'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dName$0024$0024anon$002448 from "./presto.types$-Credential-Name$$anon$48.js";
import * as $j_presto$002etypes$0024$002dCredential$002dName$0024$0024anon$002449 from "./presto.types$-Credential-Name$$anon$49.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialName$() {
  this.c5B = null;
  this.c5C = false;
  this.c5z = null;
  this.c5A = false;
  this.c5F = null;
  this.c5G = false;
  this.c5D = null;
  this.c5E = false;
  this.c5H = null;
  this.c5I = false;
}
export { $c_Lpresto_types$CredentialName$ as $c_Lpresto_types$CredentialName$ };
$p = $c_Lpresto_types$CredentialName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialName$;
/** @constructor */
function $h_Lpresto_types$CredentialName$() {
}
export { $h_Lpresto_types$CredentialName$ as $h_Lpresto_types$CredentialName$ };
$h_Lpresto_types$CredentialName$.prototype = $p;
$p.csS = (function() {
  if ((!this.c5C)) {
    this.c5B = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c5C = true;
  }
  return this.c5B;
});
$p.gr = (function() {
  if ((!this.c5A)) {
    this.c5z = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c5A = true;
  }
  return this.c5z;
});
$p.aec = (function() {
  if ((!this.c5G)) {
    this.c5F = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c5G = true;
  }
  return this.c5F;
});
$p.aea = (function() {
  if ((!this.c5E)) {
    this.c5D = new $j_presto$002etypes$0024$002dCredential$002dName$0024$0024anon$002448.$c_Lpresto_types$CredentialName$$anon$48(this);
    this.c5E = true;
  }
  return this.c5D;
});
$p.Ha = (function() {
  if ((!this.c5I)) {
    this.c5H = new $j_presto$002etypes$0024$002dCredential$002dName$0024$0024anon$002449.$c_Lpresto_types$CredentialName$$anon$49(this);
    this.c5I = true;
  }
  return this.c5H;
});
var $d_Lpresto_types$CredentialName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialName$, "presto.types$CredentialName$", ({
  Z5: 1,
  D: 1
}));
export { $d_Lpresto_types$CredentialName$ as $d_Lpresto_types$CredentialName$ };
var $n_Lpresto_types$CredentialName$;
function $m_Lpresto_types$CredentialName$() {
  if ((!$n_Lpresto_types$CredentialName$)) {
    $n_Lpresto_types$CredentialName$ = new $c_Lpresto_types$CredentialName$();
  }
  return $n_Lpresto_types$CredentialName$;
}
export { $m_Lpresto_types$CredentialName$ as $m_Lpresto_types$CredentialName$ };
//# sourceMappingURL=presto.types$-Credential-Name$.js.map
